import React, {useEffect, useState} from 'react';
import Loader from "../../../components/loader";
import {Link, useLocation, useParams} from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import axios from "../../../helpers/axios";
import sayError from "../../../helpers/sayError";
import {useNavigate} from "react-router";
import {SalesRegisterListRoute} from "../../routesConstants";
import {Helmet} from "react-helmet";
import SaleRegister from "../components/SaleRegister";

const EditSalesRegister = () => {
  const {id} = useParams();
  const { search } = useLocation();
  const [loading, setLoading]=useState(false)
  const [data, setData] = useState()
  const navigate = useNavigate()
  const start = new URLSearchParams(search).get('start')
  const buyerId = new URLSearchParams(search).get('buyerId')

  const setActualData = (oldData, newData) =>{
    if(!!oldData){
      return {...oldData, ...newData}
    }else{
      return {...newData}
    }
  }

  useEffect(() => {
    axios.get("/api/salesRegister/"+id)
      .then(({data})=>{
        console.log('editbledata',data)
        setData(data.register)
        setData(d=>setActualData(d,data.register))

      })
    if(start && buyerId){
      axios.post('/api/salesRegister/getPayments', {start, buyerId})
        .then((dataP)=>{
          setData(d=>setActualData(d,dataP.data))
        })
    }
  }, [id]);


  const breadcrumbs = (
    <Breadcrumbs aria-label="Breadcrumb" style={{paddingBottom: 15}}>
      <Link to={SalesRegisterListRoute}>Список покупателей</Link>
      {buyerId && <Link to={`${SalesRegisterListRoute}/${buyerId}`}>Список реестров</Link>}
      <Typography color="textPrimary">Реестр</Typography>
    </Breadcrumbs>
  )

  if(!data?.tableData){
    return <>{breadcrumbs}<Loader/></>
  }



  const saveRegister = (data) =>{
    setLoading(true)
    axios.patch('/api/salesRegister/'+id,data)
      .then(()=>{
        navigate(buyerId ? `${SalesRegisterListRoute}/${buyerId}` : SalesRegisterListRoute)
      })
      .catch(sayError)
      .finally(()=>setLoading(false))
  }
  return (
    <div>
      {breadcrumbs}
      <SaleRegister cb={saveRegister}
                    dataBase={data}
                    edit
                    buyerId={buyerId}
                    saving={loading}/>
    </div>
  );
};

export default EditSalesRegister;
